// extracted by mini-css-extract-plugin
module.exports = {"ratings":"StoreRatings_ratings__RuFH4","votes":"StoreRatings_votes__YV83D"};